import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/kontakt/client/ContactClient.tsx");
